import styled from 'styled-components'

import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const NotAvailableHostContainer = styled.div`
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  background-color: ${theme.colors.lighterGrey};
  display: flex;
  align-items: center;
`

export const NotAvailableHostLabel = styled.li`
  ${Font14}
  color: ${theme.colors.darkeyGrey};
  line-height: 1.55;
`

export const NotAvailableHostTextContainer = styled.div``

export const NotAvailableHostTitle = styled.div`
  font-size: 18px;
  line-height: 1.75;
  color: ${theme.colors.moreGrey};
`

export const NotAvailableHostCaptions = styled.ul`
  margin: 0;
  padding: 0 0 0 20px;
`
